import data from './analytics-semantic-model.data.json';
import {
  AnalyticsSemanticModelSchema,
  type AnalyticsSemanticModel,
} from './analytics-semantic-model.schemas';

export const ANALYTICS_SEMANTIC_MODEL: AnalyticsSemanticModel =
  AnalyticsSemanticModelSchema.parse(data);

export { AnalyticsSemanticModelSchema } from './analytics-semantic-model.schemas';
export type {
  AnalyticsSemanticCaveat,
  AnalyticsSemanticColumn,
  AnalyticsSemanticModel,
  AnalyticsSemanticRelationship,
  AnalyticsSemanticTable,
} from './analytics-semantic-model.schemas';
